/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_See_AllInputs */

const en_mobile_see_all = /** @type {(inputs: Mobile_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

const es_mobile_see_all = /** @type {(inputs: Mobile_See_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todo`)
};

/**
* | output |
* | --- |
* | "See all" |
*
* @param {Mobile_See_AllInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_see_all = /** @type {((inputs?: Mobile_See_AllInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_See_AllInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_see_all(inputs)
	return en_mobile_see_all(inputs)
});